import React, { createContext, useContext, useEffect, useState } from 'react';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext();
export function useAuth() { return useContext(AuthContext); }

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  async function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function logout() { return signOut(auth); }

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          const snap = await getDoc(doc(db, 'usuarios', user.uid));
          if (snap.exists()) {
            setUserRole(snap.data().rol || 'admin');
          } else {
            await setDoc(doc(db, 'usuarios', user.uid), {
              email: user.email,
              nombre: user.email.split('@')[0],
              rol: 'admin',
              creadoEn: new Date().toISOString(),
            });
            setUserRole('admin');
          }
        } catch (e) {
          setUserRole('admin');
        }
      } else {
        setUserRole(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const value = {
    currentUser, userRole, login, logout,
    isAdmin: userRole === 'admin',
    isTecnico: userRole === 'tecnico',
    isSecretaria: userRole === 'secretaria',
    puedeVerTodo: userRole === 'admin' || userRole === 'tecnico',
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
